import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles'
import { Editor } from '@progress/kendo-editor-react-wrapper'
import '@progress/kendo-ui'

const styles = (theme) => ({
	root: {
		...theme.mixins.gutters(),
		paddingTop: theme.spacing.unit * 2,
		paddingBottom: theme.spacing.unit * 2,
	},
})

class KendoEditor extends Component {
	render() {
		const getUrl = window.location
		const baseUrl = getUrl.protocol + '//' + getUrl.host
		return (
			<Editor
				change={this.props.onChange}
				value={this.props.value}
				encoded={false}
				stylesheets={[baseUrl + '/reset.css']}
				// resizable={{
				//   toolbar: true,
				//   /* , content: true */
				// }}
				tools={[
					'fontName',
					'fontSize',
					'foreColor',
					// 'backColor',
					// 'strikethrough',
					'bold',
					'italic',
					'underline',
					'justifyLeft',
					'justifyCenter',
					'justifyRight',
					'justifyFull',
					'insertUnorderedList',
					'insertOrderedList',
					'indent',
					'outdent',
					'createLink',
					'unlink',
					// 'insertImage',
					// 'insertFile',
					// 'subscript',
					// 'superscript',
					// 'tableWizard',
					// 'createTable',
					// 'addRowAbove',
					// 'addRowBelow',
					// 'addColumnLeft',
					// 'addColumnRight',
					// 'deleteRow',
					// 'deleteColumn',
					'formatting',
					// 'cleanFormatting',
					// 'print',
				]}
			/>
		)
	}
}

export default withStyles(styles)(KendoEditor)
